import React from 'react';
import { shape, number } from 'prop-types';
import classnames from 'classnames';

import { formattedReward, formattedFixedPrice } from '../../../../utils/promo-presentation-utils';
import { usePromoCart } from '../../../../contexts/PromoCartProvider';
import { usePromoModel } from '../../../../contexts/PromoModelProvider';
import './PromoProgressBarAdornment.scss';

export const PromoProgressAdornment = ({ rewardTier }) => {
  const { isPromoAchieved, currentPromoTier } = usePromoCart();
  const { isMsb, isBmsm } = usePromoModel();

  const isTierAchieved = isBmsm && (currentPromoTier > rewardTier.tier || isPromoAchieved);
  const {
    rewardPercent, rewardAmountPerOrder, fixedPriceTotal, minPurchaseQuantity
  } = rewardTier;

  const promoProgressAdornmentClasses = classnames({
    'promo-progress-adornment-price-tag': isMsb,
    'promo-progress-adornment-price-tag--success': isMsb && isPromoAchieved,
    'promo-progress-adornment-discount-text': isBmsm,
    'promo-progress-adornment-discount-text--right': isBmsm && !fixedPriceTotal,
    'promo-progress-adornment-discount-text--centered': isBmsm && fixedPriceTotal,
    'promo-progress-adornment-discount-text--success': isBmsm && isTierAchieved,
  });

  let adornmentText = '';
  if (isBmsm) {
    if (fixedPriceTotal) {
      // not a reward
      adornmentText = formattedFixedPrice({ fixedPriceTotal, minPurchaseQuantity });
    } else {
      adornmentText = formattedReward({ rewardPercent, rewardAmountPerOrder });
    }
  }
  if (isTierAchieved) adornmentText += ' ✔';

  return <div data-content={adornmentText} className={promoProgressAdornmentClasses} />;
};

PromoProgressAdornment.displayName = 'PromoProgressAdornment';

PromoProgressAdornment.propTypes = {
  rewardTier: shape({
    tier: number,
    rewardPercent: number,
    rewardAmountPerOrder: number,
    rewardFixedPrice: number,
    fixedPriceTotal: number
  }).isRequired,
};
